module.exports = __webpack_public_path__ + "static/media/supermessage_asset.d23b5f25.png";